/** @format */

import moment from "moment";
import { format } from "date-fns";
import { toZonedTime } from "date-fns-tz";

export const getTimeAfter = (
  mCount: number,
  unit?: moment.unitOfTime.DurationConstructor
) => moment().add(mCount, unit);

function getOrdinal(n: number): string {
  const s = ["th", "st", "nd", "rd"];
  const v = n % 100;
  return n + (s[(v - 20) % 10] || s[v] || s[0]);
}

export function formatIndexRange(
  index_start_frame: number,
  index_end_frame: number
): string {
  if (!index_start_frame || !index_end_frame) return "";
  const start = getOrdinal(index_start_frame);
  const end = getOrdinal(index_end_frame);
  return `${start}:${end}`;
}

export function formatTokenSimple(value: number | string, symbol = ""): string {
  const num = typeof value === "string" ? parseFloat(value) : value;
  if (isNaN(num)) return "";
  return num.toFixed(4) + (symbol ? ` ${symbol}` : "");
}

const getDeviceTimezone = (): string => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
};

export const formatCandleTime = (
  isoString: string,
  timeZone = getDeviceTimezone()
) => {
  if (!isoString) return "";
  const date = new Date(isoString + "Z");
  const zonedDate = toZonedTime(date, timeZone);
  return format(zonedDate, "HH:mm");
};
